import type { Language } from "~/utils/language";

const DISPLAY_LOCALE: Record<Language, string> = {
  HEB: "he-IL",
  ENG: "en-GB",
  RUS: "ru-RU",
};

export const formatDate = (date: string) => {
  const dateOnly = date.split("T")[0];
  const [year, month, day] = dateOnly.split("-");
  return `${day}/${month}/${year}`;
};

/** Date-only display for insurance (and similar) metadata — no time. */
export function formatLastUpdatedDate(
  dateStr: string | null | undefined,
  lang: Language
): string | null {
  if (!dateStr) return null;

  const normalized = dateStr.includes("T")
    ? dateStr
    : dateStr.replace(" ", "T");
  const parsed = new Date(normalized);

  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleDateString(lang === "HEB" ? "he-IL" : "en-US", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  const [year, month, day] = dateStr.split(" ")[0]?.split("-") ?? [];
  if (year && month && day) {
    return `${day}.${month}.${year}`;
  }

  return dateStr.split(" ")[0] ?? null;
}

/** Parse Masleka `TAARICH-NECHONUT` values (`YYYYMMDD`, optionally numeric). */
export function parseMaslekaCompactDate(
  value: string | number | null | undefined
): Date | null {
  if (value == null || value === "") return null;
  const dateStr = String(value).trim();
  if (!/^\d{8}$/.test(dateStr)) return null;

  const year = Number(dateStr.slice(0, 4));
  const month = Number(dateStr.slice(4, 6));
  const day = Number(dateStr.slice(6, 8));
  const date = new Date(year, month - 1, day);
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  return date;
}

export function formatMaslekaCompactDate(
  date: Date,
  lang: Language
): string {
  return date.toLocaleDateString(DISPLAY_LOCALE[lang], {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function getLatestMaslekaAsOfDate(
  values: Array<string | number | null | undefined>
): Date | null {
  let latest: Date | null = null;
  for (const value of values) {
    const date = parseMaslekaCompactDate(value);
    if (date && (!latest || date > latest)) latest = date;
  }
  return latest;
}
